<div class="user-organizations-result">
  @if (organizations().length) {
    @if (tableConfig(); as config) {
      <div class="table-wrapper">
        <ui-dataset-table [data]="organizations()" [config]="config"></ui-dataset-table>
      </div>
    }
  } @else {
    <div class="empty-state">
      {{ 'USER_ORGANIZATIONS_RESULT.EMPTY_STATE' | translate }}
    </div>
  }

  <ng-template #nameCell let-row>
    <div class="organization-name">
      <span class="organization-name__text" [class.organization-name__text--active]="isActive(row)">
        {{ row.name }}
      </span>
      @if (isActive(row)) {
        <span class="organization-name__badge">{{ 'USER_ORGANIZATIONS_RESULT.ACTIVE' | translate }}</span>
      }
    </div>
  </ng-template>
</div>
